<template>
  <section id="search-results"
    class="card has-background-dark has-text-light"
    :style="visible ? 'display: block' : 'display: none'">
    <div class="card-content">
      <div class="content list is-hoverable has-background-dark">
        <a class="list-item has-text-white has-background-dark"
          v-for="(row, index) of results"
          :key="index"
          @click="open(row)">
          {{ (index + 1) }}. {{ row[$conf.search[$store.getters['searchIndex']].id] }}
          <b-icon icon="arrow-right" type="is-white"></b-icon>
        </a>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'SearchResultsComponent',
  props: {
    visible: Boolean
  },
  data () {
    return {
      isOpen: false
    }
  },
  computed: {
    results () {
      return this.$store.getters['searchResults']
    }
  },
  mounted () {

  },
  methods: {
    open (row) {
      this.$store.dispatch('parcel', row)
      this.$map.fitTo({
        bbox: this.$map.bbox(row.geometry),
        srid: this.$conf.api.srid || 'EPSG:4326'
      })
    }
  }
}

</script>

<style lang="stylus" scoped>
#search-results
  margin: 0px 6px 26px 6px
  border-bottom: 0
  .card-content
    padding: 0
    .list
      box-shadow: none
      a.list-item
        border-radius: 0
        border-bottom: 1px solid #7a7a7a
        padding-left: 0
        padding-right: 0
        &:last-child
          border-bottom: 0
        .icon
          float: right

</style>
